<template>
  <a class="underline" target="_blank" v-bind="$attrs">
    ＞<slot name="text"></slot>
  </a>
</template>

<script>
export default {
    name: 'share'
}
</script>

<style lang="scss" scoped>
a.underline{
    margin: 0;
    padding-bottom: 0px;
    border-bottom: 1px solid $black;
    opacity: 1;
    font-weight: 500;
    line-height: 1.875em;
    &:hover{
        opacity: 0.6;
    }
    &.small {
      font-size: 1.125em;
    }
    &.large {
      font-size: 1.6875em;
      font-weight: bold;
      @media #{$maxM}{
        font-size: 1.35714em;
      }
    }
}
</style>